import { useContext } from 'react';

import { UserInfoDataContext } from 'modules/context';

export const useUserInfoData = () => {
  const context = useContext(UserInfoDataContext);
  if (!context) {
    throw new Error('useUserInfoData must be used within a UserInfoDataProvider');
  }
  return context;
};
